/**
 * THIS ISN'Y USED YET, BUT IT WILL BE USED SOON
 * It will be largely the same as SideNavBar, but we wont have the
 * Subnav, and we will instead have page level sub navs.
 */
import { Layout } from "antd";

import { RVSidebarItem } from "@regal-voice/ui";
import { usePageAvailability } from "App/routes/Hooks/usePageAvilability/usePageAvailability";
import { TOP_LEVEL_PAGES_TITLE_MAP } from "App/routes/pageNames";
import { AppPagePaths } from "App/routes/paths";

import styles from "./AppNav.module.scss";

const NAV_HOTKEYS = {
    [AppPagePaths.regalLive]: undefined,
    [AppPagePaths.agentDesktop]: "d",
    [AppPagePaths.orchestration]: "o",
    [AppPagePaths.audience]: "u",
    [AppPagePaths.liveOps]: "v",
    [AppPagePaths.convoIntel]: "c",
    [AppPagePaths.aiAgents]: "i",
    [AppPagePaths.copilot]: "l",
    [AppPagePaths.reporting]: "e",
    [AppPagePaths.settings]: "g",
} as const;

const NAV_ICONS = {
    [AppPagePaths.regalLive]: "regal-live",
    [AppPagePaths.agentDesktop]: "headset",
    [AppPagePaths.orchestration]: "journey",
    [AppPagePaths.audience]: "audience",
    [AppPagePaths.liveOps]: "queues",
    [AppPagePaths.convoIntel]: "transcripts",
    [AppPagePaths.aiAgents]: "ai-agents",
    [AppPagePaths.copilot]: "loading-3-quarters",
    [AppPagePaths.reporting]: "bar-chart",
    [AppPagePaths.settings]: "settings",
} as const;

export function AppNav(): JSX.Element {
    const {
        showLiveOps,
        showOrchestration,
        showConvoIntel,
        showAIAgents,
        showAudience,
        showRegalLive,
        mockRegalLiveAlternative,
        showRegalCopilot,
        showReporting,
        showSettings,
        showADToAgent,
        showADToAdmin,
    } = usePageAvailability();

    const regalLivePath = mockRegalLiveAlternative ? AppPagePaths.regalLiveAi : AppPagePaths.regalLive;

    const showBottomBar = showReporting || showSettings || showRegalCopilot;
    return (
        <>
            <Layout.Sider collapsed={true} collapsedWidth={64} className={styles.sidebar}>
                {showADToAgent && (
                    <RVSidebarItem
                        href={AppPagePaths.agentDesktop}
                        hotkey={NAV_HOTKEYS[AppPagePaths.agentDesktop]}
                        icon={NAV_ICONS[AppPagePaths.agentDesktop]}
                    >
                        {TOP_LEVEL_PAGES_TITLE_MAP[AppPagePaths.agentDesktop]}
                    </RVSidebarItem>
                )}

                {showRegalLive && (
                    <RVSidebarItem href={regalLivePath} icon={NAV_ICONS[AppPagePaths.regalLive]}>
                        {TOP_LEVEL_PAGES_TITLE_MAP[AppPagePaths.regalLive]}
                    </RVSidebarItem>
                )}
                {showAIAgents && (
                    <RVSidebarItem
                        href={AppPagePaths.aiAgents}
                        hotkey={NAV_HOTKEYS[AppPagePaths.aiAgents]}
                        icon={NAV_ICONS[AppPagePaths.aiAgents]}
                    >
                        {TOP_LEVEL_PAGES_TITLE_MAP[AppPagePaths.aiAgents]}
                    </RVSidebarItem>
                )}
                {showConvoIntel && (
                    <RVSidebarItem
                        href={AppPagePaths.convoIntel}
                        hotkey={NAV_HOTKEYS[AppPagePaths.convoIntel]}
                        icon={NAV_ICONS[AppPagePaths.convoIntel]}
                    >
                        {TOP_LEVEL_PAGES_TITLE_MAP[AppPagePaths.convoIntel]}
                    </RVSidebarItem>
                )}
                {showOrchestration && (
                    <RVSidebarItem
                        href={AppPagePaths.orchestration}
                        hotkey={NAV_HOTKEYS[AppPagePaths.orchestration]}
                        icon={NAV_ICONS[AppPagePaths.orchestration]}
                        activeRoutes={[`${AppPagePaths.orchestration}/*`]}
                    >
                        {TOP_LEVEL_PAGES_TITLE_MAP[AppPagePaths.orchestration]}
                    </RVSidebarItem>
                )}
                {showAudience && (
                    <RVSidebarItem
                        href={AppPagePaths.audience}
                        hotkey={NAV_HOTKEYS[AppPagePaths.audience]}
                        icon={NAV_ICONS[AppPagePaths.audience]}
                    >
                        {TOP_LEVEL_PAGES_TITLE_MAP[AppPagePaths.audience]}
                    </RVSidebarItem>
                )}

                {showLiveOps && (
                    <RVSidebarItem
                        href={AppPagePaths.liveOps}
                        hotkey={NAV_HOTKEYS[AppPagePaths.liveOps]}
                        icon={NAV_ICONS[AppPagePaths.liveOps]}
                        activeRoutes={[`${AppPagePaths.liveOps}/*`]}
                    >
                        {TOP_LEVEL_PAGES_TITLE_MAP[AppPagePaths.liveOps]}
                    </RVSidebarItem>
                )}

                {showADToAdmin && (
                    <RVSidebarItem
                        href={AppPagePaths.agentDesktop}
                        hotkey={NAV_HOTKEYS[AppPagePaths.agentDesktop]}
                        icon={NAV_ICONS[AppPagePaths.agentDesktop]}
                    >
                        {TOP_LEVEL_PAGES_TITLE_MAP[AppPagePaths.agentDesktop]}
                    </RVSidebarItem>
                )}

                {showBottomBar && (
                    <div className={styles.sidebarBottomItem}>
                        {showRegalCopilot && (
                            <RVSidebarItem
                                href={AppPagePaths.copilot}
                                hotkey={NAV_HOTKEYS[AppPagePaths.copilot]}
                                icon={NAV_ICONS[AppPagePaths.copilot]}
                            >
                                {TOP_LEVEL_PAGES_TITLE_MAP[AppPagePaths.copilot]}
                            </RVSidebarItem>
                        )}
                        {showReporting && (
                            <RVSidebarItem
                                href={AppPagePaths.reporting}
                                hotkey={NAV_HOTKEYS[AppPagePaths.reporting]}
                                icon={NAV_ICONS[AppPagePaths.reporting]}
                            >
                                {TOP_LEVEL_PAGES_TITLE_MAP[AppPagePaths.reporting]}
                            </RVSidebarItem>
                        )}
                        {showSettings && (
                            <RVSidebarItem
                                href={`${AppPagePaths.settings}`}
                                hotkey={NAV_HOTKEYS[AppPagePaths.settings]}
                                icon={NAV_ICONS[AppPagePaths.settings]}
                                activeRoutes={[`${AppPagePaths.settings}/*`]}
                            >
                                {TOP_LEVEL_PAGES_TITLE_MAP[AppPagePaths.settings]}
                            </RVSidebarItem>
                        )}
                    </div>
                )}
            </Layout.Sider>
        </>
    );
}
